export default "__VITE_ASSET__B0zlx46V__"